import React from 'react';

const HR = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_137"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_137)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="#150A99"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4H9V5H8V4ZM10 3H11V5H10V3ZM12 4H13V5H12V4Z"
        fill="#0091E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3H12V5H11V3ZM9 3H10V5H9V3Z"
        fill="#150A99"
      />
    </g>
    <mask
      id="mask1_3_137"
      maskUnits="userSpaceOnUse"
      x="8"
      y="5"
      width="5"
      height="6"
    >
      <path
        d="M13 8.5C13 9.88 11.88 11 10.5 11C9.12 11 8 9.88 8 8.5V5H13V8.5Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_3_137)">
      <path
        d="M13 8.5C13 9.88 11.88 11 10.5 11C9.12 11 8 9.88 8 8.5V5H13V8.5Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 10H10V11H9V10ZM11 10H12V11H11V10ZM10 9H11V10H10V9ZM9 8H10V9H9V8ZM11 8H12V9H11V8ZM10 7H11V8H10V7ZM9 6H10V7H9V6ZM11 6H12V7H11V6ZM10 5H11V6H10V5ZM12 5H13V6H12V5ZM12 7H13V8H12V7ZM12 9H13V10H12V9ZM8 9H9V10H8V9ZM8 7H9V8H8V7ZM8 5H9V6H8V5Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default HR;
